import { ReactComponent as SpinnerIcon } from 'img/icons/spinner.svg';
import { ReactComponent as VKUISpinnerIcon } from 'img/icons/vkui/spinner_44.svg';
import React, { memo, ReactElement } from 'react';

import styles from './Spinner.css';
import { IProps, SpinnerTypes } from './Spinner.types';

export const Spinner = memo(({ type = SpinnerTypes.cloud }: IProps): ReactElement => {
    const Component =
        {
            [SpinnerTypes.cloud]: SpinnerIcon,
            [SpinnerTypes.vkui]: VKUISpinnerIcon,
        }[type] || SpinnerIcon;
    return <Component className={styles.root} width={40} height={40} />;
});

Spinner.displayName = 'Spinner';
